import { render } from "./network.vue?vue&type=template&id=2b8be15c&scoped=true"
import script from "./network.vue?vue&type=script&lang=js"
export * from "./network.vue?vue&type=script&lang=js"

import "./network.vue?vue&type=style&index=0&id=2b8be15c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tap-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8be15c"]])

export default __exports__